(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("adminAdvertsController", adminAdvertsController);

  adminAdvertsController.$inject = ["AdvertsApi", "Adverts", "handleError"];

  function adminAdvertsController(AdvertsApi, Adverts, handleError) {
    var vm = this;

    // properties
    vm.isLoading = false;
    vm.page = 1;
    vm.sort = "created_at";
    vm.order = "desc";
    vm.filters = {
      status: "pending",
      title: "",
      page: 1,
      page_size: 15,
    };
    vm.adverts = {};

    // methods
    vm.getAdverts = getAdverts;
    vm.editAdvert = editAdvert;
    vm.createAdvert = createAdvert;

    /**
     * Retrieves adverts from the api and adds to scope
     * @return {void}
     */
    function getAdverts() {
      vm.isLoading = true;
      AdvertsApi.get(
        vm.filters,
        function (response) {
          vm.adverts = response;
          vm.isLoading = false;
        },
        function (err) {
          handleError(err);
          vm.isLoading = false;
        },
      );
    }

    /**
     * Edits the advert via a modal, and updates model in this controller
     * @param  {int} advertId - ID of advert to edit
     * @return {void}
     */
    function editAdvert(advertId) {
      Adverts.edit(advertId).result.then(
        function (updatedAdvert) {
          // Find and update the advert on this page
          angular.forEach(vm.adverts.data, function (advert, index) {
            if (advert.id === updatedAdvert.id) {
              if (updatedAdvert.deleted) {
                vm.adverts.data.splice(index, 1);
              } else {
                vm.adverts.data[index] = updatedAdvert;
              }
            }
          });
        },
        function (err) {
          handleError(err);
        },
      );
    }

    /**
     * Creates an advert then refreshes adverts
     * @return {void}
     */
    function createAdvert() {
      Adverts.create().result.then(function () {
        getAdverts();
      });
    }

    getAdverts();
  }
})(angular);
